<div class="chat-sidebar" [class.open]="isOpen">
  <div class="chat-sidebar-header">
    <button *ngIf="showChatBox" class="back-btn" (click)="backToList()">
      <i class="mdi mdi-arrow-left"></i>
    </button>
    <h5>{{ showChatBox ? 'Chat' : (userType === 'admin' ? 'Vendors' : 'Admins') }}</h5>
    <button class="close-btn" (click)="closeSidebar()">
      <i class="mdi mdi-close"></i>
    </button>
  </div>
  <div class="chat-sidebar-body">
    <perfect-scrollbar style="height: calc(100vh - 60px);" *ngIf="!showChatBox">
      <div class="search-container">
        <div class="search-box">
          <i class="mdi mdi-magnify search-icon"></i>
          <input 
            type="text" 
            class="search-input" 
            [(ngModel)]="searchQuery"
            (ngModelChange)="onSearchChange()"
            name="search"
            placeholder="Search..."
          />
        </div>
      </div>
      <div class="user-list">
        <div *ngFor="let user of filteredUserList" class="user-item" (click)="selectUser(user)" [class.has-unseen]="user.unseen">
          <div class="user-info">
            <div class="user-name-wrapper">
              <span class="red-dot" *ngIf="user.unseen"></span>
              <h6>{{ user.name || (user.first_name + ' ' + user.last_name) }}</h6>
            </div>
            <p *ngIf="user.user_type !== 'staff'">{{ user.email }}</p>
            <p *ngIf="user.user_type === 'staff'">
              {{ user.email }}<br>
              <span *ngIf="user.stores && user.stores.length > 0">
                (<strong>Store Name:</strong> {{ user.stores[0].store_name }})<br>
                <span *ngIf="user.stores[0].vendor">
                  (<strong>Vendor Name:</strong> {{ user.stores[0].vendor.name }}, <strong>Email:</strong> {{ user.stores[0].vendor.email }})
                </span>
              </span>
            </p>
            <p class="last-message-time" *ngIf="user.last_message_at">
              <i class="mdi mdi-clock-outline"></i> {{ user.last_message_at }}
            </p>
          </div>
          <div class="user-badges">
            <span class="unread-badge" *ngIf="user.conversation_id && user.unread_count > 0">
              {{ user.unread_count }}
            </span>
            <span class="user-type-badge" *ngIf="user.user_type">{{ user.user_type }}</span>
          </div>
        </div>
        <div *ngIf="!filteredUserList || filteredUserList.length === 0" class="no-users">
          <p>No users found</p>
        </div>
      </div>
    </perfect-scrollbar>

    <div class="chat-box" *ngIf="showChatBox">
      <div class="messages-container">
        <div *ngIf="loadingMessages" class="loading-messages">
          <p>Loading messages...</p>
        </div>
        <div *ngIf="!loadingMessages && messages.length === 0 && !conversationId" class="no-messages">
          <p>No conversation yet. Start chatting!</p>
        </div>
        <div *ngIf="!loadingMessages && messages.length === 0 && conversationId" class="no-messages">
          <p>No messages yet. Start the conversation!</p>
        </div>
        <perfect-scrollbar *ngIf="!loadingMessages && messages.length > 0" style="height: 100%; width: 100%;">
          <div class="message-list">
            <ng-container *ngFor="let msg of messages; let i = index">
              <div class="subject-divider" *ngIf="msg.subject && (i === 0 || messages[i-1].subject !== msg.subject)">
                <span>{{ msg.subject }}</span>
              </div>
              <div class="message-item" [class.sent]="msg.sender_id == currentUserId">
                <div class="message-content">
                  <p class="sender-name" *ngIf="msg.sender_id != currentUserId">
                    {{ msg.sender_first_name }} {{ msg.sender_last_name }}
                  </p>
                  <p class="message-text">{{ msg.body }}</p>
                  <span class="message-time">{{ msg.created_at }}</span>
                </div>
              </div>
            </ng-container>
          </div>
        </perfect-scrollbar>
      </div>
      <div class="chat-form">
        <div class="input-wrapper">
          <input 
            type="text" 
            class="form-control subject-input" 
            [(ngModel)]="subject"
            name="subject"
            [placeholder]="lastSubject ? 'Subject (optional)' : 'Subject (required)'"
          />
        </div>
        <div class="message-input-wrapper">
          <textarea 
            class="form-control message-input" 
            [(ngModel)]="message"
            name="message"
            rows="3" 
            placeholder="Type your message..."
          ></textarea>
          <button 
            class="send-btn" 
            (click)="sendMessage()" 
            [disabled]="!canSendMessage()"
          >
            <i class="mdi mdi-send"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="chat-sidebar-overlay" *ngIf="isOpen" (click)="closeSidebar()"></div>
